import { render, staticRenderFns } from "./beregnung-rueckmeldung.vue?vue&type=template&id=2972447b&scoped=true&"
import script from "./beregnung-rueckmeldung.vue?vue&type=script&lang=js&"
export * from "./beregnung-rueckmeldung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972447b",
  null
  
)

export default component.exports